import type { WebappResponse } from '@eventbrite/event-listing-service-client';
import { releaseFetchWithOverrideRecovery } from '@/lib/release/pageSourceOverride';

export const fetchFreshEventContext = async (eventId: string): Promise<WebappResponse | null> => {
  try {
    const response = await releaseFetchWithOverrideRecovery(`/e/api/${eventId}/context`, {
      method: 'GET',
      cache: 'no-store',
    });
    if (!response.ok) {
      return null;
    }

    return (await response.json()) as WebappResponse;
  } catch {
    return null;
  }
};
